webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_models__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_coach__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jsonwebtoken__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jsonwebtoken__);









/* harmony default export */ __webpack_exports__["a"] = ({
  store: localStorage,
  getHttpOptions: function getHttpOptions() {
    var token = this.store.getItem('currentToken');
    var options = {
      baseURL: "https://lesopens-api.onrender.com",
      headers: { 'jwt-auth': token }
    };
    return options;
  },
  ping: function ping() {
    return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('ping', this.getHttpOptions()).then(function (res) {
      return res.status === 200;
    }).catch(function (e) {
      return false;
    });
  },
  auth: function auth(username, password) {
    return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('auth/login', {
      username: username,
      password: password
    }, this.getHttpOptions()).then(function (res) {
      return {
        user: new __WEBPACK_IMPORTED_MODULE_4__api_models__["a" /* User */]().load(res.data.user),
        token: res.data.token,
        role: res.data.role
      };
    }).catch(function (error) {
      if (error.response) {
        throw new Error(error.response.data);
      } else {
        console.log(error.message);
        throw new Error('Oh! Sorry for the service error');
      }
    });
  },
  register: function register(username, password, data) {
    return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('auth/register', {
      username: username,
      password: password,
      data: data
    }, this.getHttpOptions()).then(function (res) {
      return {
        user: new __WEBPACK_IMPORTED_MODULE_4__api_models__["a" /* User */]().load(res.data.user),
        token: res.data.token
      };
    }).catch(function (error) {
      if (error.response) {
        throw new Error(error.response.data);
      } else {
        console.log(error.message);
        throw new Error('Oh! Sorry for the service error');
      }
    });
  },
  setCurrentUser: function setCurrentUser(me) {
    this.store.setItem('currentUser', me.user.dumps());
    this.store.setItem('currentToken', me.token);
  },
  updateCurrentUser: function updateCurrentUser(user) {
    this.store.setItem('currentUser', user.dumps());
  },
  getCurrentUser: function getCurrentUser() {
    var data = this.store.getItem('currentUser');
    if (data) {
      var me = new __WEBPACK_IMPORTED_MODULE_4__api_models__["a" /* User */]().loads(data);
      return me;
    } else {
      return undefined;
    }
  },
  hasCurrentUser: function hasCurrentUser() {
    return this.store.getItem('currentUser') !== null;
  },
  removeCurrentUser: function removeCurrentUser() {
    this.store.removeItem('currentUser');
    this.store.removeItem('currentToken');
  },
  hasRole: function hasRole(name) {
    var token = this.store.getItem('currentToken');
    var decoded = __WEBPACK_IMPORTED_MODULE_7_jsonwebtoken___default.a.decode(token);
    if (!decoded.roles) return false;
    return decoded.roles.includes(name);
  },
  update: function update(me) {
    this.updateCurrentUser(me);
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/athlete', me.dump(), this.getHttpOptions()) // push to server - async call of server
    .catch(function (e) {
      return console.log(e.message);
    });
    return me;
  },
  loadResource: function loadResource(path) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(path, _this.getHttpOptions()).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this.store.setItem('res/' + path, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(res.data));

                        case 2:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()).catch(function (e) {
                return console.log(e.message);
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  loadLocalResource: function loadLocalResource(name) {
    try {
      return JSON.parse(this.store.getItem(name));
    } catch (e) {
      console.log('Unable to read local resource: ' + name);
      return undefined;
    }
  },
  cacheLoad: function cacheLoad() {
    var _this2 = this;

    this.loadResource('activity/skill/list');
    this.loadResource('activity/list');
    this.loadResource('activity/programs/taskTypes');
    this.loadResource('activity/programs/list');

    //  load dynamically the programs based on the program list
    this.getProgramList().forEach(function (item, index) {
      var name = item[0];
      _this2.loadResource('activity/program/' + name);
    });
  },
  changePassword: function changePassword(me, newPassword) {
    return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/auth/changePassword', {
      username: me.getUsername(),
      newPassword: newPassword
    }, this.getHttpOptions());
  },
  changeUsername: function changeUsername(me, newUsername) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/auth/changeUsername', {
                previousUsername: me.getUsername(),
                newUsername: newUsername
              }, _this3.getHttpOptions());

            case 2:
              me.setUsername(newUsername);
              _this3.update(me);

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getSkills: function getSkills() {
    return this.loadLocalResource('res/activity/skill/list');
  },
  updateSkills: function updateSkills(skills) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // call service to store the skills
              __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/activity/skill/list', skills, _this4.getHttpOptions());
              // update the local resource
              _context4.next = 3;
              return _this4.store.setItem('res/activity/skill/list', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(skills));

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getProgramList: function getProgramList() {
    return this.loadLocalResource('res/activity/programs/list');
  },
  updateProgramList: function updateProgramList(programs) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/activity/programs/list', programs, _this5.getHttpOptions());
              _context5.next = 3;
              return _this5.store.setItem('res/activity/programs/list', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(programs));

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getActivityList: function getActivityList() {
    var forceLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (forceLoad) this.loadResource('activity/list');
    return this.loadLocalResource('res/activity/list');
  },
  updateActivityList: function updateActivityList(activities) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/activity/list', activities, _this6.getHttpOptions());
              _context6.next = 3;
              return _this6.store.setItem('res/activity/list', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(activities));

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getProgram: function getProgram(name) {
    var programs = this.getProgramList();
    var desc = programs.filter(function (item) {
      return item[0] === name;
    })[0]; // return array [key, program desc]
    var program = {};
    program.name = name;
    program.description = desc[1];
    program.sessions = this.loadLocalResource('res/activity/program/' + name);
    if (!program.sessions) {
      program.sessions = {};
    }
    return program;
  },
  updateProgram: function updateProgram(name, program) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var programs, index;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              // Update program description into the list
              programs = _this7.getProgramList();
              index = programs.findIndex(function (item) {
                return item[0] === name;
              }); // return array [key, program desc]

              programs[index][0] = program.name;
              programs[index][1] = program.description;
              _this7.updateProgramList(programs);

              // call service to store the program sessions
              _context7.next = 7;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/activity/program/' + program.name, program.sessions, _this7.getHttpOptions());

            case 7:
              // update the local resource
              _this7.store.setItem('res/activity/program/' + program.name, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(program.sessions));

            case 8:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getProgramTaskTypes: function getProgramTaskTypes() {
    return this.loadLocalResource('res/activity/programs/taskTypes');
  },
  getNextSessions: function getNextSessions(me) {
    if (me.athlete.gotoNextSessions || me.athlete.forceSessionRefresh) {
      // Update the next sessions
      if (!me.athlete.forceSessionRefresh) me.athlete.progSeqNum++; // incr the seq counter
      me.athlete.nextSessions = __WEBPACK_IMPORTED_MODULE_5__api_coach__["a" /* default */].createWeekPlan(me);
      me.athlete.forceSessionRefresh = false; // always reset to false forceRefresh
      me.athlete.gotoNextSessions = false; // always reset to false
      this.update(me);
    }
    // return only the non completed sessions
    return this.getRemainingSessions(me);
  },
  getRemainingSessions: function getRemainingSessions(me) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(me.athlete.nextSessions).filter(function (session) {
      if (!session.status) return true;
      return session.status !== 'Completed';
    });
  },
  getPastSessions: function getPastSessions(me) {
    var url = 'athlete/' + me.id() + '/past-session/list';
    return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, this.getHttpOptions()).then(function (res) {
      return res.data;
    });
  },
  addPastSession: function addPastSession(me, session) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var sessions;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              sessions = _this8.getPastSessions(me);

              sessions[session.id] = session;
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('athlete/' + me.id() + '/past-session/', session, _this8.getHttpOptions());

            case 4:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  getPastSession: function getPastSession(me, id) {
    var url = 'athlete/' + me.id() + '/past-session?sessionId=' + id;
    return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, this.getHttpOptions()).then(function (res) {
      return res.data;
    });
  }
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css_dist_css_materialize_css__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css_dist_css_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css_dist_css_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      name: undefined
    };
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].hasCurrentUser()) {
      this.name = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCurrentUser().athlete.name;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].cacheLoad(); // load dynamic resources in cache (Localstorage)
    }
    __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.FloatingActionButton.init(this.$refs.fab, {
      toolbarEnabled: true
    });
    __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.Dropdown.init(this.$refs.moreMenu);

    this.$router.replace({ name: 'Home' }); // go to home by default
  },
  methods: {
    isAuthenticated: function isAuthenticated() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].hasCurrentUser();
    },
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].removeCurrentUser();
      this.$router.push({ name: 'Login' });
    },
    isCoach: function isCoach() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].hasRole('coach');
    }
  }

});

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cards_TrackBodyRemind__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cards_SessionCompleted__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_SessionRemaining__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cards_InitRecordRemind__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cards_TargetsRemind__ = __webpack_require__(498);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      user: undefined,
      name: undefined
    };
  },

  components: { TrackBodyRemind: __WEBPACK_IMPORTED_MODULE_2__components_cards_TrackBodyRemind__["a" /* default */], SessionCompleted: __WEBPACK_IMPORTED_MODULE_3__components_cards_SessionCompleted__["a" /* default */], SessionRemaining: __WEBPACK_IMPORTED_MODULE_4__components_cards_SessionRemaining__["a" /* default */], InitRecordRemind: __WEBPACK_IMPORTED_MODULE_5__components_cards_InitRecordRemind__["a" /* default */], TargetsRemind: __WEBPACK_IMPORTED_MODULE_6__components_cards_TargetsRemind__["a" /* default */] },
  created: function created() {
    this.user = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCurrentUser();
    this.name = this.user.athlete.name;
  },
  mounted: function mounted() {
    if (this.user.athlete.isFirstLogin) {
      __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.TapTarget.init(this.$parent.$refs.tap, {}).open();
      this.user.athlete.isFirstLogin = false;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].update(this.user);
    }
    // While activity changed reset the PSN
    this.$events.$on('selected-activity-changed', function () {
      var user = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCurrentUser();
      user.athlete.progSeqNum = 0;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].update(user);
    });
  },

  computed: {
    countRemainingSessions: function countRemainingSessions() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getNextSessions(this.user).length;
    }
  },
  methods: {
    isInit: function isInit() {
      return !this.user.athlete.recordsInit; // is initialized?
    },
    remindTrackBody: function remindTrackBody() {
      return !this.user.athlete.waist || this.isRecursive(2) && !this.isDone('trackBody');
    },
    isRecursive: function isRecursive(n) {
      var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

      return this.user.athlete.progSeqNum % period === n; // every n weeks, starting at t0+n
    },
    isDone: function isDone(card) {
      if (!this.user.athlete.doneActions) return false;
      return this.user.athlete.doneActions[card];
    },
    done: function done(card) {
      if (!this.user.athlete.doneActions) this.user.athlete.doneActions = {};
      this.user.athlete.doneActions[card] = true;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].update(this.user);
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trackBodyRemind',
  props: {
    'name': String,
    'callback': Function
  },
  methods: {
    call: function call(card) {
      if (this.callback) this.callback(card);
    }
  }

});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionCompleted_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab2edf34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionCompleted_vue__ = __webpack_require__(494);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionCompleted_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab2edf34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionCompleted_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trackBodyRemind',
  props: {
    'name': String,
    'user': Object,
    'callback': Function
  },
  methods: {
    gotoNext: function gotoNext() {
      this.user.athlete.gotoNextSessions = true;
      this.user.athlete.doneActions = {}; // reset actions performed on the past week
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getNextSessions(this.user); // weird. update is performed here
      if (this.callback) this.callback(this.user);
    }
  }

});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sessionRemaining',
  props: {
    'name': String,
    'count': Number
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InitRecordRemind_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4c84622_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InitRecordRemind_vue__ = __webpack_require__(497);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InitRecordRemind_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4c84622_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InitRecordRemind_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'initRecordRemind',
  props: {
    'name': String
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trackBodyRemind',
  props: {
    'name': String,
    'callback': Function
  },
  methods: {
    call: function call(card) {
      if (this.callback) this.callback(card);
    }
  }

});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_error__ = __webpack_require__(293);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      username: undefined,
      password: undefined,
      environment: "production",
      appVersion: "0.5.1",
      apiPing: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].ping().then(function (ok) {
      _this.apiPing = ok;
    });
  },

  methods: {
    login: function login() {
      var _this2 = this;

      // Auth
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].auth(this.username, this.password).then(function (me) {
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setCurrentUser(me);
        _this2.$reloadApp();
      }).catch(function (e) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_error__["a" /* displayError */])(e);
      });
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = displayError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);


function displayError(e) {
  if (e.response) {
    __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.toast({ html: e.response.data });
  } else {
    __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.toast({ html: e.message });
  }
  return true;
}

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_error__ = __webpack_require__(293);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register',
  data: function data() {
    return {
      name: undefined,
      email: undefined,
      password: undefined,
      gender: 'male',
      weight: undefined,
      activities: [],
      trainingPrograms: undefined
    };
  },
  created: function created() {
    this.activities = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getActivityList(true);
  },

  methods: {
    changePrograms: function changePrograms(e) {
      var programs = e.target._value;
      this.trainingPrograms = programs;
    },
    register: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var userData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.email && this.name) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_materialize_css___default.a.toast({ html: 'Name and Email are required' }));

              case 2:
                if (!this.$refs.email.classList.contains('invalid')) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_materialize_css___default.a.toast({ html: 'An email address is required' }));

              case 4:
                // create user
                userData = {
                  name: this.capitalize(this.name),
                  email: this.email,
                  gender: this.gender,
                  trainingPrograms: this.trainingPrograms,
                  sessionsPerWeek: this.trainingPrograms.length,
                  weight: this.weight,
                  registrationDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(),
                  isFirstLogin: true
                };
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].register(this.email, this.password, userData).catch(function (e) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__helpers_error__["a" /* displayError */])(e);
                });

              case 7:

                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].auth(this.email, this.password).then(function (me) {
                  __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].setCurrentUser(me);
                  _this.$reloadApp();
                }).catch(function (e) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__helpers_error__["a" /* displayError */])(e);
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function register() {
        return _ref.apply(this, arguments);
      }

      return register;
    }(),
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_athlete_BodyShape__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_athlete_Training__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_athlete_Infos__ = __webpack_require__(513);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'athlete',
  props: ['tab'],
  components: { BodyShape: __WEBPACK_IMPORTED_MODULE_2__components_athlete_BodyShape__["a" /* default */], Training: __WEBPACK_IMPORTED_MODULE_3__components_athlete_Training__["a" /* default */], Infos: __WEBPACK_IMPORTED_MODULE_4__components_athlete_Infos__["a" /* default */] },
  data: function data() {
    return {
      user: undefined
    };
  },
  created: function created() {
    this.user = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCurrentUser();
  },
  mounted: function mounted() {
    var tabs = __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.Tabs.init(this.$refs.tabs, {});
    if (this.tab) tabs.select(this.tab);
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bodyShape',
  props: {
    'user': Object,
    'callback': Function
  },
  data: function data() {
    return {
      weight: undefined,
      waist: undefined,
      name: undefined,
      gender: undefined
    };
  },
  created: function created() {
    this.weight = this.user.athlete.weight;
    this.waist = this.user.athlete.waist;
    this.name = this.user.athlete.name;
    this.gender = this.user.athlete.gender;
  },

  watch: {
    waist: function waist(val) {
      this.user.athlete.waist = val === '' ? undefined : val;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update(this.user);
    },
    weight: function weight(val) {
      this.user.athlete.weight = val === '' ? undefined : val;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update(this.user);
    }
  },
  methods: {
    log: function log() {
      this.user.addBodyChange({
        weight: this.weight,
        waist: this.waist
      });
      this.user.athlete.weight = this.weight;
      this.user.athlete.waist = this.waist;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update(this.user);
      if (this.callback) this.callback(this.user);
      __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Weight and waist logged!' });
    }
  },
  computed: {
    bodyFat: function bodyFat() {
      this.gender = this.gender; // to maintain reactivity
      return this.user.bodyFat(this.weight, this.waist);
    }
  },
  filters: {
    NaN: function NaN(value) {
      if (isNaN(value)) {
        return '- ';
      } else {
        return value;
      }
    }
  }

});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'training',
  props: {
    'user': Object,
    'callback': Function
  },
  data: function data() {
    return {
      activities: [],
      trainingPrograms: []
    };
  },
  created: function created() {
    this.trainingPrograms = this.user.athlete.trainingPrograms;
    this.activities = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getActivityList();
  },

  methods: {
    changePrograms: function changePrograms(e) {
      var programs = e.target._value;
      this.user.athlete.trainingPrograms = programs;
      this.user.athlete.sessionsPerWeek = programs.length;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update(this.user);
      this.$events.$emit('selected-activity-changed', {});
      __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Selected activity changed!' });
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'training',
  props: {
    'user': Object,
    'callback': Function
  },
  data: function data() {
    return {
      name: this.user.athlete.name,
      email: this.user.athlete.email,
      gender: this.user.athlete.gender,
      password: undefined
    };
  },
  created: function created() {
    this.name = this.user.athlete.name;
    this.email = this.user.athlete.email;
    this.gender = this.user.athlete.gender;
  },

  watch: {
    name: function name(val) {
      this.user.athlete.name = val;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update(this.user);
      __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Name changed!' });
    },
    gender: function gender(val) {
      this.user.athlete.gender = val;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update(this.user);
      __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Gender changed!' });
    }
  },
  methods: {
    changePassword: function changePassword() {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].changePassword(this.user, this.password).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Password changed!' });
      }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Error, password not changed!' });
      });
    },
    changeUsername: function changeUsername() {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].changeUsername(this.user, this.email).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Email/login changed!' });
      }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Error, Email/login not changed!' });
      });
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bodyLog',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var user = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCurrentUser();
    var labels = [];
    var values = [];
    var logs = user.athlete.bodyLog;
    for (var i in logs) {
      labels.push(__WEBPACK_IMPORTED_MODULE_1_moment___default()(logs[i].dt));
      values.push(user.bodyFat(logs[i].weight, logs[i].waist));
    }
    var config = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: '%body fat',
          backgroundColor: 'red',
          borderColor: 'red',
          fill: false,
          data: values
        }]
      },
      options: {
        title: {
          text: 'Body fat history'
        },
        scales: {
          xAxes: [{
            type: 'time',
            distribution: 'linear',
            time: {
              round: 'day',
              unit: 'day',
              parser: 'll',
              tooltipFormat: 'll HH:mm'
            },
            scaleLabel: {
              display: true,
              labelString: 'Date'

            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: '% of body mass'
            }
          }]
        }
      }
    };

    var ctx = this.$refs.canvas.getContext('2d');
    window.myLine = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
  }
});

/***/ }),
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sessions_NextSessionList__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sessions_PastSessionList__ = __webpack_require__(522);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sessions',
  props: ['tab'],
  components: { NextSessionList: __WEBPACK_IMPORTED_MODULE_2__components_sessions_NextSessionList__["a" /* default */], PastSessionList: __WEBPACK_IMPORTED_MODULE_3__components_sessions_PastSessionList__["a" /* default */] },
  data: function data() {
    return {
      user: undefined
    };
  },
  created: function created() {
    this.user = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCurrentUser();
  },
  mounted: function mounted() {
    var tabs = __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.Tabs.init(this.$refs.tabs, {});
    if (this.tab) tabs.select(this.tab);
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_SessionCompleted__ = __webpack_require__(286);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nextSessionList',
  props: {
    'user': Object
  },
  components: { SessionCompleted: __WEBPACK_IMPORTED_MODULE_1__components_cards_SessionCompleted__["a" /* default */] },
  data: function data() {
    return {
      nextSessions: [], // list of sessions
      name: undefined
    };
  },
  created: function created() {
    this.name = this.user.athlete.name;
    this.nextSessions = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getNextSessions(this.user);
  },

  computed: {
    // sort the next session by ascending index
    sortedNextSessions: function sortedNextSessions() {
      return this.nextSessions.sort(function (a, b) {
        return a.index - b.index;
      });
    }
  },
  methods: {
    callbackSessionListUpdated: function callbackSessionListUpdated(user) {
      this.user = user;
      this.nextSessions = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getNextSessions(this.user); // refresh
    },
    isCoach: function isCoach() {
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].hasRole('coach');
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pastSessionList',
  props: {
    'user': Object
  },
  data: function data() {
    return {
      pastSessions: []
    };
  },
  created: function created() {
    var _this = this;

    this.getPastSessions().then(function (sessions) {
      _this.pastSessions = sessions;
    });
  },

  computed: {
    // sort the next session by descending time
    sortedPastSessions: function sortedPastSessions() {
      return this.pastSessions.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.dt) - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.dt);
      });
    }
  },
  methods: {
    getPastSessions: function getPastSessions() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getPastSessions(this.user).then(function (sessions) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(sessions);
      });
    }
  },
  filters: {
    statusIconify: function statusIconify(val) {
      switch (val) {
        case 'Completed':
          return 'done';
        case 'Missed':
          return 'call_missed';
      }
    },
    toDate: function toDate(val) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).format('ll');
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dot__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_marked__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dompurify__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_records_InputRecord__ = __webpack_require__(305);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'session',
  props: {
    isPastSession: Boolean,
    session: Object,
    user: Object
  },
  components: { InputRecord: __WEBPACK_IMPORTED_MODULE_7__components_records_InputRecord__["a" /* default */] },
  data: function data() {
    return {
      tasks: []
    };
  },
  created: function created() {
    this.tasks = this.session.tasks;
    if (!this.isPastSession) {
      // Collect the skills to record
      var skills = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getSkills();
      for (var i in this.tasks) {
        if (this.tasks[i].withRecord) {
          var skillName = this.tasks[i].withRecord;
          var skill = skills[skillName];
          // Get exiting record value
          if (skill) {
            var record = this.user.athlete.records[skillName];
            if (record) {
              if (record.unit === 'time') {
                skill.valueMinutes = record.valueMinutes;
                skill.valueSeconds = record.valueSeconds;
              } else {
                skill.value = record.value;
              }
            }
            skill.skill = skillName;
            this.tasks[i].recordSkill = skill;
          } else {
            throw new Error('Use of undefined ' + skillName);
          }
        }
      }
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.Collapsible.init(this.$refs.collapsible, {});
    __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.Modal.init(this.$refs.dismissModal, {});
  },

  methods: {
    complete: function complete() {
      // add new records to the athlete
      for (var i in this.tasks) {
        var task = this.tasks[i];
        if (task.recordSkill) {
          // if a value is set
          if (task.recordSkill.value || task.recordSkill.valueMinutes || task.recordSkill.valueSeconds) {
            this.user.addRecord(task.recordSkill);
          }
        }
      }
      // Change the status of the session to completed
      this.session.dt = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      this.session.status = 'Completed';
      this.user.athlete.nextSessions[this.session.id] = this.session;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].addPastSession(this.user, this.session);
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].update(this.user);
      this.$router.push({ name: 'Sessions' });
    },
    dismiss: function dismiss() {
      this.session.dt = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      this.session.status = 'Missed';
      delete this.user.athlete.nextSessions[this.session.id]; // remove the session from the list
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].addPastSession(this.user, this.session);
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].update(this.user);
      this.$router.push({ name: 'Sessions' });
    },
    renderInstruction: function renderInstruction(tpl) {
      var htmlTpl = __WEBPACK_IMPORTED_MODULE_6_dompurify___default.a.sanitize(__WEBPACK_IMPORTED_MODULE_5_marked___default()(tpl));
      var fRender = __WEBPACK_IMPORTED_MODULE_3_dot___default.a.template(htmlTpl);
      var dTpl = fRender(this.user);
      return dTpl;
    },
    renderTitle: function renderTitle(tpl) {
      var fRender = __WEBPACK_IMPORTED_MODULE_3_dot___default.a.template(tpl);
      return fRender(this.user);
    },
    hasTimer: function hasTimer(task) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(parseInt(task.capTime));
    },
    getTimer: function getTimer(task) {
      var args = task.capTime.split('-');
      switch (args[0]) {
        case 'countdown':
          return { mode: args[0], options: { delay: parseInt(args[1]) } };
        case 'clock':
          return { mode: args[0], options: { cap: parseInt(args[1]) } };
        case 'EMOM':
          return { mode: args[0], options: { roundDuration: parseInt(args[1]) * 60, rounds: parseInt(args[2]) } };
      }
    },
    getTaskDuration: function getTaskDuration(task) {
      if (task.capTime) {
        if (this.hasTimer(task)) {
          var timer = this.getTimer(task);
          switch (timer.mode) {
            case 'clock':
              return timer.options.cap;
            case 'countdown':
              return timer.options.delay;
            case 'EMOM':
              return timer.options.rounds * timer.options.roundDuration / 60;
            default:
              return task.capTime;
          }
        } else {
          return task.capTime;
        }
      } else {
        return undefined;
      }
    }
  },
  computed: {
    sortedTasks: function sortedTasks() {
      return this.tasks.sort(function (a, b) {
        return a.index - b.index;
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputRecord_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_384a6cdc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputRecord_vue__ = __webpack_require__(533);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_384a6cdc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inputRecord',
  props: {
    record: Object,
    isReadOnly: Boolean
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_records_PerformanceList__ = __webpack_require__(536);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'records',
  props: ['tab'],
  components: { PerformanceList: __WEBPACK_IMPORTED_MODULE_2__components_records_PerformanceList__["a" /* default */] },
  data: function data() {
    return {
      user: undefined
    };
  },
  created: function created() {
    this.user = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCurrentUser();
  },
  mounted: function mounted() {
    var tabs = __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.Tabs.init(this.$refs.tabs, {});
    if (this.tab) tabs.select(this.tab);
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cards_InitRecordRemind__ = __webpack_require__(289);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'targetList',
  props: {
    'user': Object
  },
  components: { InitRecordRemind: __WEBPACK_IMPORTED_MODULE_2__components_cards_InitRecordRemind__["a" /* default */] },
  data: function data() {
    return {
      records: [],
      name: undefined
    };
  },
  created: function created() {
    this.name = this.user.athlete.name;

    /* eslint no-unused-vars : 0 */
    var user = this.user; // user variable scope for target formula

    // sort records as array based on the name structure eg. 1RM-Squat
    this.records = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.user.athlete.records).sort(function (a, b) {
      var extract = function extract(fullname) {
        var s = fullname.split('-');
        if (s.length === 1) return { group: s[0] };
        return { group: s[1], name: s[0] };
      };
      var aSkill = extract(a.skill);
      var bSkill = extract(b.skill);
      if (aSkill.group === bSkill.group) {
        return aSkill.name > bSkill.name ? 1 : -1;
      } else {
        return aSkill.group > bSkill.group ? 1 : -1;
      }
    });

    // compute the targets
    for (var i in this.records) {
      /* eslint no-eval: 0 */
      this.records[i].target = eval(this.records[i].targetFormula);
      if (this.records[i].unit === 'time') {
        var elapseInSec = this.records[i].valueMinutes * 60 + this.records[i].valueSeconds;
        var targetElapseInSec = this.records[i].target.minutes * 60 + this.records[i].target.seconds;
        this.records[i].gap = ((elapseInSec - targetElapseInSec) / targetElapseInSec * 100).toFixed(1);
      } else {
        this.records[i].target = this.records[i].target.toFixed(0);
        this.records[i].gap = ((this.records[i].target - this.records[i].value) / this.records[i].value * 100).toFixed(1);
      }
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recordLog',
  props: ['skill'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var skill = this.skill;
    var user = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCurrentUser();
    var labels = [];
    var values = [];
    var logs = user.athlete.recordLog[skill];

    var skillName = logs.length > 0 ? logs[0].name : undefined;
    var description = logs.length > 0 ? logs[0].description : undefined;
    var isTime = logs[0].unit === 'time';

    for (var i in logs.sort(function (a, b) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(a.dt) - __WEBPACK_IMPORTED_MODULE_1_moment___default()(b.dt);
    })) {
      labels.push(__WEBPACK_IMPORTED_MODULE_1_moment___default()(logs[i].dt));
      if (logs[i].unit === 'time') {
        values.push(parseInt(logs[i].valueMinutes) * 60.0 + parseInt(logs[i].valueSeconds));
      } else {
        values.push(logs[i].value);
      }
    }
    var config = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: skillName,
          backgroundColor: 'red',
          borderColor: 'red',
          fill: false,
          data: values
        }]
      },
      options: {
        title: {
          text: 'Performance history'
        },
        scales: {
          xAxes: [{
            type: 'time',
            distribution: 'linear',
            time: {
              round: 'day',
              unit: 'day',
              parser: 'll',
              tooltipFormat: 'll HH:mm'
            },
            scaleLabel: {
              display: true,
              labelString: 'Date'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: description + (isTime ? ' (in seconds)' : '')
            }
          }]
        }
      }
    };

    var ctx = this.$refs.canvas.getContext('2d');
    window.myLine = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_records_InputRecord__ = __webpack_require__(305);

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'initRecords',
  components: { InputRecord: __WEBPACK_IMPORTED_MODULE_2__components_records_InputRecord__["a" /* default */] },
  data: function data() {
    return {
      user: undefined,
      records: []
    };
  },
  created: function created() {
    this.user = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCurrentUser();
    // get the list of skills marked as init==true
    var skills = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getSkills();
    var selectedSkillNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(skills).filter(function (skill) {
      return skills[skill].init;
    });
    // add the skill to the user records
    var records = [];
    selectedSkillNames.forEach(function (skillName) {
      var record = skills[skillName];
      record.skill = skillName;
      records.push(record);
    });
    this.records = records;
  },
  mounted: function mounted() {},

  watch: {
    records: {
      deep: true,
      handler: function handler() {
        var toUpdate = false;
        for (var i in this.records) {
          var record = this.records[i];
          if (record.value || record.valueMinutes || record.valueSeconds) {
            this.user.addRecord(record);
            toUpdate = true;
          }
        }
        // update user records and set the user initialized
        if (toUpdate) {
          this.user.athlete.recordsInit = true;
          __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].update(this.user);
        }
      }
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_coach_ProgramList__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_coach_SkillEdit__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_coach_ActivityList__ = __webpack_require__(558);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'coach',
  props: ['tab'],
  components: { ProgramList: __WEBPACK_IMPORTED_MODULE_2__components_coach_ProgramList__["a" /* default */], SkillList: __WEBPACK_IMPORTED_MODULE_3__components_coach_SkillEdit__["a" /* default */], ActivityList: __WEBPACK_IMPORTED_MODULE_4__components_coach_ActivityList__["a" /* default */] },
  data: function data() {
    return {
      user: undefined
    };
  },
  created: function created() {
    this.user = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCurrentUser();
  },
  mounted: function mounted() {
    var tabs = __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.Tabs.init(this.$refs.tabs, {});
    if (this.tab) tabs.select(this.tab);
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_object__ = __webpack_require__(313);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'programList',
  props: {
    user: Object
  },
  components: {},
  data: function data() {
    return {
      programs: [],
      seq_copy: 1

    };
  },
  mounted: function mounted() {
    var _this = this;

    this.programs = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getProgramList();
    this.$events.$on('programs-changed', function () {
      _this.programs = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getProgramList();
    });
  },

  methods: {
    refresh: function refresh() {
      this.programs = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getProgramList();
    },
    addProgram: function addProgram() {
      var n = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.programs).length;
      var newKey = 'new-' + n;
      var nProgram = {
        code: '??',
        name: 'New program',
        type: undefined,
        intensity: undefined
      };
      this.programs.push([newKey, nProgram]);
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateProgramList(this.programs);
      __WEBPACK_IMPORTED_MODULE_3_materialize_css___default.a.toast({ html: 'Program added! Please change the key' });
    },
    copyProgram: function copyProgram(toCopyKey, toCopyDesc) {
      // Copy program description
      var newKey = toCopyKey + '-copy';
      var existing = this.programs.findIndex(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        return key === newKey;
      });
      if (existing !== -1) {
        __WEBPACK_IMPORTED_MODULE_3_materialize_css___default.a.toast({ html: 'Duplicate already exist! Please change the key before' });
        return;
      }
      var nProgram = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_object__["a" /* cloneData */])(toCopyDesc);
      nProgram.name = 'Copy of ' + nProgram.name;
      this.programs.push([newKey, nProgram]);
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateProgramList(this.programs);
      // Copy sessions
      var program = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_object__["a" /* cloneData */])(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getProgram(toCopyKey));
      program.description = nProgram;
      program.name = newKey;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateProgram(newKey, program);
      __WEBPACK_IMPORTED_MODULE_3_materialize_css___default.a.toast({ html: 'Program copied! Please change the key' });
    },
    deleteProgram: function deleteProgram(toRemoveKey) {
      if (!confirm('Delete the program?')) return;
      var existing = this.programs.findIndex(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            val = _ref4[1];

        return key === toRemoveKey;
      });
      if (existing !== -1) {
        this.programs.splice(existing, 1);
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateProgramList(this.programs);
      }
      __WEBPACK_IMPORTED_MODULE_3_materialize_css___default.a.toast({ html: 'Program removed!' });
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function cloneData(obj) {
  var jsonObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
  return JSON.parse(jsonObj);
}

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(4);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'skills',
  props: {
    user: Object
  },
  components: {},
  data: function data() {
    return {
      skillTypes: [],
      skills: []
    };
  },
  computed: {
    sortedSkills: function sortedSkills() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.skills).sort();
    }
  },
  created: function created() {
    this.skillTypes = __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getProgramTaskTypes();
    this.skills = __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getSkills();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4_materialize_css___default.a.Collapsible.init(this.$refs.collapsible, {});
  },

  methods: {
    addSkill: function addSkill() {
      var n = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.skills).length;
      var newKey = 'new-' + n;
      var nSkill = {};
      nSkill[newKey] = {
        type: undefined,
        name: 'New',
        description: '',
        unit: undefined,
        targetFormula: '1.5* user.athlete.weight * 0.85',
        init: false
      };
      this.skills = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(nSkill, this.skills); // to refresh the object
    },
    removeSkill: function removeSkill(name) {
      delete this.skills[name];
      this.skills = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.skills);
    },
    save: function save() {
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].updateSkills(this.skills);
      __WEBPACK_IMPORTED_MODULE_4_materialize_css___default.a.toast({ html: 'Skills saved' });
    },
    onChangeSkillKey: function onChangeSkillKey(oldKey, skill, $event) {
      var newKey = $event.target.value;
      this.skills[newKey] = skill;
      delete this.skills[oldKey];
      this.skills = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.skills); // refresh the object
    }
  }
});

/***/ }),
/* 315 */,
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'activities',
  props: {
    user: Object
  },
  components: {},
  data: function data() {
    return {
      activities: [],
      programs: []
    };
  },
  created: function created() {
    this.activities = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getActivityList();
    this.programs = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getProgramList();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.Collapsible.init(this.$refs.collapsible, {});
  },

  methods: {
    add: function add() {
      var nActivity = {
        name: 'New' + this.activities.length,
        programs: []
      };
      this.activities.push(nActivity);
    },
    remove: function remove(index) {
      this.activities.splice(index, 1);
    },
    save: function save() {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].updateActivityList(this.activities);
      __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.toast({ html: 'Activities saved' });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_array__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_object__ = __webpack_require__(313);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'program',
  props: {
    programKey: String,
    user: Object
  },
  components: {},
  data: function data() {
    return {
      program: undefined,
      taskTypes: [],
      skills: [],
      sessions: undefined,
      intensities: ['Low', 'Medium', 'High', 'Rest'],
      tabs: undefined
    };
  },
  computed: {
    // Sort numerically removing the W prefix
    sortedSessions: function sortedSessions() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.sessions).sort(function (v1, v2) {
        var i1 = parseInt(v1[0].replace('W', ''));
        var i2 = parseInt(v2[0].replace('W', ''));
        if (i1 < i2) return -1;
        if (i1 > i2) return 1;
        if (i1 === i2) return 0;
      });
    }
  },
  created: function created() {
    this.program = __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getProgram(this.programKey);
    this.sessions = this.program.sessions;
    this.taskTypes = __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getProgramTaskTypes();
    this.skills = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getSkills());
  },
  mounted: function mounted() {
    this.tabs = __WEBPACK_IMPORTED_MODULE_4_materialize_css___default.a.Tabs.init(this.$refs.tabs, {});
    __WEBPACK_IMPORTED_MODULE_4_materialize_css___default.a.Collapsible.init(this.$refs.collapsible, {});
  },

  methods: {
    onChangeSessionKey: function onChangeSessionKey(oldKey, session, $event) {
      var newKey = $event.target.value;
      this.sessions[newKey] = session;
      delete this.sessions[oldKey];
      this.sessions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.sessions); // refresh the object
    },
    insertTask: function insertTask(session, after) {
      session.tasks.splice(session.tasks.indexOf(after) + 1, 0, {
        type: undefined,
        title: 'New task',
        capTime: 5,
        instruction: ''
      });
    },
    removeTask: function removeTask(session, toRemove) {
      var i = session.tasks.indexOf(toRemove);
      session.tasks = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_array__["c" /* arrayRemove */])(session.tasks, i);
    },
    moveTaskUp: function moveTaskUp(session, task) {
      var i = session.tasks.indexOf(task);
      session.tasks = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_array__["b" /* arrayMoveUp */])(session.tasks, i);
    },
    moveTaskDown: function moveTaskDown(session, task) {
      var i = session.tasks.indexOf(task);
      session.tasks = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_array__["a" /* arrayMoveDown */])(session.tasks, i);
    },

    addSession: function addSession() {
      var n = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sessions).length;
      var newKey = 'W' + n;
      var nSession = {};
      nSession[newKey] = {
        title: 'New session',
        tasks: [{
          index: 0,
          type: undefined,
          title: 'New task',
          capTime: undefined,
          instruction: undefined
        }] };
      this.sessions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(nSession, this.sessions); // refresh the program object
      this.tabs.select('sessions');
    },
    copySession: function copySession(name) {
      var n = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sessions).length;
      var newKey = 'W' + n;
      var nSession = {};
      nSession[newKey] = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_object__["a" /* cloneData */])(this.sessions[name]);
      nSession[newKey].title = 'Copy of ' + this.sessions[name].title;
      this.sessions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(nSession, this.sessions);
    },
    removeSession: function removeSession(name) {
      delete this.sessions[name];
      this.sessions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.sessions); // refresh the object
    },
    save: function save() {
      this.program.sessions = this.sessions;
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].updateProgram(this.programKey, this.program);
      if (this.programKey !== this.program.name) {
        this.$events.$emit('programs-changed', {});
      }
      __WEBPACK_IMPORTED_MODULE_4_materialize_css___default.a.toast({ html: 'Program saved' });
      this.$router.replace({ name: 'Coach', params: { tab: 'programs' } });
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'credits',
  data: function data() {
    return {
      user: undefined,
      progSeqNum: undefined,
      appVersion: undefined,
      environment: undefined
    };
  },
  created: function created() {
    this.user = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCurrentUser();
    this.progSeqNum = this.user.athlete.progSeqNum;
    this.appVersion = "0.5.1";
    this.environment = "production";
  },

  methods: {
    isDevMode: function isDevMode() {
      return "production" !== 'production' || true;
    },
    forceSessionUpdate: function forceSessionUpdate() {
      if (this.isDevMode) {
        this.user.athlete.forceSessionRefresh = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update(this.user);
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast({ html: 'Program Sequence Number forced changed' });
      }
    }
  },
  watch: {
    progSeqNum: function progSeqNum(val) {
      this.user.athlete.progSeqNum = val;
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'device',
  props: ['tab'],
  components: {},
  data: function data() {
    return {
      user: undefined,
      deviceName: undefined,
      deviceId: undefined,
      deviceIsConnected: false,
      accelero_x: 0,
      accelero_y: 0,
      accelero_z: 0,
      accelero_distance: 0,
      accelero_distance_max: 0,
      accelero_distance_sum: 0
    };
  },
  created: function created() {
    this.user = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCurrentUser();
    this.device = {};
  },
  mounted: function mounted() {},

  methods: {
    reset: function reset() {
      this.accelero_distance_max = 0;
      this.accelero_distance_sum = 0;
    },
    displayDeviceInfo: function displayDeviceInfo() {
      var _this = this;

      navigator.bluetooth.requestDevice({ filters: [{ services: ['fitness_machine'] }] }).then(function (device) {
        return device.gatt.connect();
      }).then(function (server) {
        return server.getPrimaryService('fitness_machine');
      }).then(function (service) {
        return service.getCharacteristic('2d5f3e71-bb02-48c6-9419-263b13ccc6c4');
      }).then(function (characteristic) {
        return characteristic.startNotifications().then(function (characteristic) {
          characteristic.addEventListener('characteristicvaluechanged', _this.handleAccelerometerCharacteristicValueChanged);
          console.log('Notifications have been started.');
          _this.deviceName = characteristic.service.device.name;
          _this.deviceIsConnected = true;
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleAccelerometerCharacteristicValueChanged: function handleAccelerometerCharacteristicValueChanged(event) {
      var value = event.target.value; // array of Float32[3]
      this.accelero_x = value.getFloat32(0, 'littleEndian');
      this.accelero_y = value.getFloat32(4, 'littleEndian');
      this.accelero_z = value.getFloat32(8, 'littleEndian');
      var newAcceleroDistance = Math.pow(Math.abs(Math.pow(this.accelero_x, 3) + Math.pow(this.accelero_y, 3) + Math.pow(this.accelero_z, 3)), 1 / 3);

      this.accelero_distance_max = Math.max(this.accelero_distance_max, newAcceleroDistance);
      this.accelero_distance = newAcceleroDistance;
      this.accelero_distance_sum = this.accelero_distance_sum + newAcceleroDistance;
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__(572);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Add global filters
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('pluralize', __WEBPACK_IMPORTED_MODULE_3__filters__["d" /* pluralize */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('capitalize', __WEBPACK_IMPORTED_MODULE_3__filters__["a" /* capitalize */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('intensityColor', __WEBPACK_IMPORTED_MODULE_3__filters__["c" /* intensityColor */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('iconifyTask', __WEBPACK_IMPORTED_MODULE_3__filters__["b" /* iconifyTask */]);

console.log('Environment: ' + "production");
console.log('Application version: ' + "0.5.1");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$reloadApp = function () {
  location.replace('/');
};
var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$events = eventBus;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 321 */,
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394047ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(488);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394047ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */,
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





var User = function User() {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, User);

  this.athlete = {
    id: undefined,
    name: undefined,
    email: undefined,
    gender: undefined,
    sessionsPerWeek: undefined, // integer
    trainingPrograms: undefined, // list of program codes
    weight: undefined,
    waist: undefined,
    registrationDate: undefined,
    isFirstLogin: undefined,
    bodyLog: [],
    records: {},
    nextSessions: {},
    recordLog: {},
    progSeqNum: 0,
    week: undefined,
    forceSessionRefresh: true, // by default refresh the session list
    recordsInit: false,
    gotoNextSessions: false
  };
  this.id = function () {
    return this.athlete.id;
  };
  this.getUsername = function () {
    return this.athlete.email;
  };
  this.setUsername = function (username) {
    this.athlete.email = username;
  };
  this.load = function (data) {
    this.athlete = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.athlete, data);
    return this;
  };
  this.loads = function (str) {
    return this.load(JSON.parse(str));
  };
  this.dump = function () {
    return this.athlete;
  };
  this.dumps = function () {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.dump());
  };
  this.bodyFat = function (weight, waist) {
    var bf = 0;
    if (this.athlete.gender === 'male') {
      bf = (-98.42 + 4.15 * waist / 2.54 - 0.082 * weight * 2.2) / (weight * 2.2);
    } else {
      bf = (-76.76 + 4.15 * waist / 2.54 - 0.082 * weight * 2.2) / (weight * 2.2);
    }
    return (bf * 100).toFixed(1);
  };
  this.addBodyChange = function (body) {
    var log = {
      dt: __WEBPACK_IMPORTED_MODULE_3_moment___default()(),
      weight: body.weight,
      waist: body.waist
    };
    if (this.athlete.bodyLog) {
      this.athlete.bodyLog.push(log);
    } else {
      this.athlete.bodyLog = [log];
    }
  };
  this.addRecord = function (record) {
    // if it is the first record, init the log array
    if (!this.athlete.recordLog[record.skill]) this.athlete.recordLog[record.skill] = [];
    // add the record to the log
    record.dt = __WEBPACK_IMPORTED_MODULE_3_moment___default()(); // set the record date
    // if type is time, compute the value as # of seconds
    if (record.unit === 'time') {
      record.value = (record.valueMinutes * 60 + record.valueSeconds) / 60; // decimal representation of minutes
      record.valueText = record.valueMinutes + "'" + record.valueSeconds + "''";
    }
    this.athlete.recordLog[record.skill].push(record);
    // update the current record
    this.athlete.records[record.skill] = record;
  };
  this.getRecord = function (skill) {
    var percentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.0;
    var defaultVal = arguments[2];

    var record = this.athlete.records[skill];
    if (record) {
      if (record.unit === 'time') {
        return Math.round(percentage * (record.valueMinutes * 60 + record.valueSeconds));
      } else {
        return Math.round(record.value * percentage);
      }
    } else if (defaultVal) {
      return defaultVal;
    } else {
      return ' - ';
    }
  };
};

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 106,
	"./af.js": 106,
	"./ar": 107,
	"./ar-dz": 108,
	"./ar-dz.js": 108,
	"./ar-kw": 109,
	"./ar-kw.js": 109,
	"./ar-ly": 110,
	"./ar-ly.js": 110,
	"./ar-ma": 111,
	"./ar-ma.js": 111,
	"./ar-sa": 112,
	"./ar-sa.js": 112,
	"./ar-tn": 113,
	"./ar-tn.js": 113,
	"./ar.js": 107,
	"./az": 114,
	"./az.js": 114,
	"./be": 115,
	"./be.js": 115,
	"./bg": 116,
	"./bg.js": 116,
	"./bm": 117,
	"./bm.js": 117,
	"./bn": 118,
	"./bn.js": 118,
	"./bo": 119,
	"./bo.js": 119,
	"./br": 120,
	"./br.js": 120,
	"./bs": 121,
	"./bs.js": 121,
	"./ca": 122,
	"./ca.js": 122,
	"./cs": 123,
	"./cs.js": 123,
	"./cv": 124,
	"./cv.js": 124,
	"./cy": 125,
	"./cy.js": 125,
	"./da": 126,
	"./da.js": 126,
	"./de": 127,
	"./de-at": 128,
	"./de-at.js": 128,
	"./de-ch": 129,
	"./de-ch.js": 129,
	"./de.js": 127,
	"./dv": 130,
	"./dv.js": 130,
	"./el": 131,
	"./el.js": 131,
	"./en-SG": 132,
	"./en-SG.js": 132,
	"./en-au": 133,
	"./en-au.js": 133,
	"./en-ca": 134,
	"./en-ca.js": 134,
	"./en-gb": 135,
	"./en-gb.js": 135,
	"./en-ie": 136,
	"./en-ie.js": 136,
	"./en-il": 137,
	"./en-il.js": 137,
	"./en-nz": 138,
	"./en-nz.js": 138,
	"./eo": 139,
	"./eo.js": 139,
	"./es": 140,
	"./es-do": 141,
	"./es-do.js": 141,
	"./es-us": 142,
	"./es-us.js": 142,
	"./es.js": 140,
	"./et": 143,
	"./et.js": 143,
	"./eu": 144,
	"./eu.js": 144,
	"./fa": 145,
	"./fa.js": 145,
	"./fi": 146,
	"./fi.js": 146,
	"./fo": 147,
	"./fo.js": 147,
	"./fr": 148,
	"./fr-ca": 149,
	"./fr-ca.js": 149,
	"./fr-ch": 150,
	"./fr-ch.js": 150,
	"./fr.js": 148,
	"./fy": 151,
	"./fy.js": 151,
	"./ga": 152,
	"./ga.js": 152,
	"./gd": 153,
	"./gd.js": 153,
	"./gl": 154,
	"./gl.js": 154,
	"./gom-latn": 155,
	"./gom-latn.js": 155,
	"./gu": 156,
	"./gu.js": 156,
	"./he": 157,
	"./he.js": 157,
	"./hi": 158,
	"./hi.js": 158,
	"./hr": 159,
	"./hr.js": 159,
	"./hu": 160,
	"./hu.js": 160,
	"./hy-am": 161,
	"./hy-am.js": 161,
	"./id": 162,
	"./id.js": 162,
	"./is": 163,
	"./is.js": 163,
	"./it": 164,
	"./it-ch": 165,
	"./it-ch.js": 165,
	"./it.js": 164,
	"./ja": 166,
	"./ja.js": 166,
	"./jv": 167,
	"./jv.js": 167,
	"./ka": 168,
	"./ka.js": 168,
	"./kk": 169,
	"./kk.js": 169,
	"./km": 170,
	"./km.js": 170,
	"./kn": 171,
	"./kn.js": 171,
	"./ko": 172,
	"./ko.js": 172,
	"./ku": 173,
	"./ku.js": 173,
	"./ky": 174,
	"./ky.js": 174,
	"./lb": 175,
	"./lb.js": 175,
	"./lo": 176,
	"./lo.js": 176,
	"./lt": 177,
	"./lt.js": 177,
	"./lv": 178,
	"./lv.js": 178,
	"./me": 179,
	"./me.js": 179,
	"./mi": 180,
	"./mi.js": 180,
	"./mk": 181,
	"./mk.js": 181,
	"./ml": 182,
	"./ml.js": 182,
	"./mn": 183,
	"./mn.js": 183,
	"./mr": 184,
	"./mr.js": 184,
	"./ms": 185,
	"./ms-my": 186,
	"./ms-my.js": 186,
	"./ms.js": 185,
	"./mt": 187,
	"./mt.js": 187,
	"./my": 188,
	"./my.js": 188,
	"./nb": 189,
	"./nb.js": 189,
	"./ne": 190,
	"./ne.js": 190,
	"./nl": 191,
	"./nl-be": 192,
	"./nl-be.js": 192,
	"./nl.js": 191,
	"./nn": 193,
	"./nn.js": 193,
	"./pa-in": 194,
	"./pa-in.js": 194,
	"./pl": 195,
	"./pl.js": 195,
	"./pt": 196,
	"./pt-br": 197,
	"./pt-br.js": 197,
	"./pt.js": 196,
	"./ro": 198,
	"./ro.js": 198,
	"./ru": 199,
	"./ru.js": 199,
	"./sd": 200,
	"./sd.js": 200,
	"./se": 201,
	"./se.js": 201,
	"./si": 202,
	"./si.js": 202,
	"./sk": 203,
	"./sk.js": 203,
	"./sl": 204,
	"./sl.js": 204,
	"./sq": 205,
	"./sq.js": 205,
	"./sr": 206,
	"./sr-cyrl": 207,
	"./sr-cyrl.js": 207,
	"./sr.js": 206,
	"./ss": 208,
	"./ss.js": 208,
	"./sv": 209,
	"./sv.js": 209,
	"./sw": 210,
	"./sw.js": 210,
	"./ta": 211,
	"./ta.js": 211,
	"./te": 212,
	"./te.js": 212,
	"./tet": 213,
	"./tet.js": 213,
	"./tg": 214,
	"./tg.js": 214,
	"./th": 215,
	"./th.js": 215,
	"./tl-ph": 216,
	"./tl-ph.js": 216,
	"./tlh": 217,
	"./tlh.js": 217,
	"./tr": 218,
	"./tr.js": 218,
	"./tzl": 219,
	"./tzl.js": 219,
	"./tzm": 220,
	"./tzm-latn": 221,
	"./tzm-latn.js": 221,
	"./tzm.js": 220,
	"./ug-cn": 222,
	"./ug-cn.js": 222,
	"./uk": 223,
	"./uk.js": 223,
	"./ur": 224,
	"./ur.js": 224,
	"./uz": 225,
	"./uz-latn": 226,
	"./uz-latn.js": 226,
	"./uz.js": 225,
	"./vi": 227,
	"./vi.js": 227,
	"./x-pseudo": 228,
	"./x-pseudo.js": 228,
	"./yo": 229,
	"./yo.js": 229,
	"./zh-cn": 230,
	"./zh-cn.js": 230,
	"./zh-hk": 231,
	"./zh-hk.js": 231,
	"./zh-tw": 232,
	"./zh-tw.js": 232
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = ({
  createWeekPlan: function createWeekPlan(me) {
    var plan = {};

    // Build the plan for the list of selected programs
    me.athlete.trainingPrograms.forEach(function (name, index) {
      var program = new GenericProgram(me, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getProgram(name));
      plan[program.id()] = program.build(index);
    });
    return plan;
  }
});

var ProgramSession = function ProgramSession(id, name) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProgramSession);

  this.id = id;
  this.index = undefined;
  this.shortCode = undefined;
  this.intensity = undefined;
  this.name = name;
  this.type = undefined;
  this.restBefore = false;
  this.tasks = [];
};

var GenericProgram = function () {
  function GenericProgram(me, program) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GenericProgram);

    this.me = me;
    this.code = program.code;
    this.name = program.name;
    this.intensity = program.intensity;
    this.type = program.type;
    this.templateSessions = program.sessions;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GenericProgram, [{
    key: 'id',
    value: function id() {
      return this.code + '-' + this.me.athlete.progSeqNum + '-' + this.me.id();
    }
  }, {
    key: 'build',
    value: function build(index) {
      var session = new ProgramSession(this.id(), this.name);
      session.index = index;
      session.shortCode = this.code;
      session.intensity = this.intensity;
      session.type = this.type;
      var i = this.me.athlete.progSeqNum % __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.templateSessions).length;
      var templateSession = this.templateSessions['W' + i];
      if (templateSession) {
        session = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(session, templateSession);
      }
      return session;
    }
  }]);

  return GenericProgram;
}();

/***/ }),
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 394 */,
/* 395 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 432 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.0","/opt/render/project/src"]],"_development":true,"_from":"elliptic@6.5.0","_id":"elliptic@6.5.0","_inBundle":false,"_integrity":"sha512-eFOJTMyCYb7xtE/caJ6JJu+bhi67WCYNbkGSknu20pmM8Ke/bqOfdnZWxyoGN26JgfxTbXrsCkEw4KheCT/KGg==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.0","saveSpec":null,"fetchSpec":"6.5.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.0.tgz","_spec":"6.5.0","_where":"/opt/render/project/src","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.0"}

/***/ }),
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ul',{staticClass:"dropdown-content",attrs:{"id":"dropdownMore"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'Credits' }}},[_vm._v("Credits")])],1),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")])])]),_vm._v(" "),_c('nav',[_c('div',{staticClass:"nav-wrapper"},[_c('a',{staticClass:"brand-logo center logo-text",attrs:{"href":"/"}},[_vm._v("Les Opens")]),_vm._v(" "),(_vm.isAuthenticated())?_c('ul',{staticClass:"right"},[_c('li',[_c('a',{ref:"moreMenu",staticClass:"dropdown-trigger",attrs:{"href":"#!","data-target":"dropdownMore"}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('router-view',[_c('Login')],1)],1),_vm._v(" "),(_vm.isAuthenticated())?_c('div',{ref:"fab",staticClass:"fixed-action-btn toolbar",attrs:{"id":"fab-menu"}},[_vm._m(0),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{staticClass:"btn-floating",attrs:{"to":{ name: 'Athlete' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("accessibility")])])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn-floating",attrs:{"to":{ name: 'Sessions' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("fitness_center")])])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn-floating",attrs:{"to":{ name: 'Records' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("flag")])])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn-floating",attrs:{"to":{ name: 'Device' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("sports_esports")])])],1),_vm._v(" "),(_vm.isCoach())?_c('li',[_c('router-link',{staticClass:"btn-floating",attrs:{"to":{ name: 'Coach' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("developer_mode")])])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isAuthenticated())?_c('div',{ref:"tap",staticClass:"tap-target",attrs:{"data-target":"fab-menu"}},[_c('div',{staticClass:"tap-target-content"},[_c('div',{staticClass:"container white-text",staticStyle:{"margin-top":"70px"}},[_c('h5',[_vm._v("Aloha "+_vm._s(_vm.name))]),_vm._v(" "),_c('p',[_vm._v("\n          Welcome to Les Opens ! The app to reach the next level within open sessions along your regular crossfit\n          workout.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Have fun and work hard!")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn-floating btn-large red"},[_c('i',{staticClass:"large material-icons"},[_vm._v("menu")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_Login__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_auth_Register__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Athlete__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_athlete_BodyLog__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Sessions__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sessions_Session__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Records__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_records_RecordLog__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_records_InitRecords__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Coach__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_coach_ProgramEdit__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Credits__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Device__ = __webpack_require__(570);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_auth_Login__["a" /* default */],
    meta: {
      public: true
    }
  }, {
    path: '/register',
    name: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_5__components_auth_Register__["a" /* default */],
    meta: {
      public: true
    }
  }, {
    path: '/athlete',
    name: 'Athlete',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Athlete__["a" /* default */],
    props: true
  }, {
    path: '/sessions',
    name: 'Sessions',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Sessions__["a" /* default */],
    props: true
  }, {
    path: '/session/:session',
    name: 'Session',
    component: __WEBPACK_IMPORTED_MODULE_9__components_sessions_Session__["a" /* default */],
    props: true
  }, {
    path: '/records',
    name: 'Records',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Records__["a" /* default */],
    props: true
  }, {
    path: '/records-init',
    name: 'InitRecords',
    component: __WEBPACK_IMPORTED_MODULE_12__components_records_InitRecords__["a" /* default */],
    props: true
  }, {
    path: '/record-log/:skill',
    name: 'RecordLog',
    component: __WEBPACK_IMPORTED_MODULE_11__components_records_RecordLog__["a" /* default */],
    props: true
  }, {
    path: '/body-log',
    name: 'BodyLog',
    component: __WEBPACK_IMPORTED_MODULE_7__components_athlete_BodyLog__["a" /* default */],
    props: true
  }, {
    path: '/coach',
    name: 'Coach',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Coach__["a" /* default */],
    props: true
  }, {
    path: '/coach/program-edit',
    name: 'ProgramEdit',
    component: __WEBPACK_IMPORTED_MODULE_14__components_coach_ProgramEdit__["a" /* default */],
    props: true
  }, {
    path: '/credits',
    name: 'Credits',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Credits__["a" /* default */],
    props: true
  }, {
    path: '/device',
    name: 'Device',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Device__["a" /* default */],
    props: true
  }]
});

// intercept routing for auth
router.beforeEach(function (to, from, next) {
  var isPublic = to.matched.some(function (record) {
    return record.meta.public;
  });
  var onlyWhenLoggedOut = to.matched.some(function (record) {
    return record.meta.onlyWhenLoggedOut;
  });
  var loggedIn = !!__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].hasCurrentUser();

  if (!isPublic && !loggedIn) {
    return next({
      name: 'Login',
      query: { redirect: to.fullPath // Store the full path to redirect the user to after login
      } });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next({ name: 'Home' });
  }
  next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 490 */,
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fbff83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(500);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fbff83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackBodyRemind_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5530887f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackBodyRemind_vue__ = __webpack_require__(493);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackBodyRemind_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5530887f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackBodyRemind_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card purple darken-1"},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Track your shape")]),_vm._v(" "),_c('p',[_vm._v("Aloha "+_vm._s(_vm.name)+", remind to track regularly your amazing body shape.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{attrs:{"to":{ name: 'Athlete', params: {tab:'body'}}}},[_c('span',_vm._g({},_vm.call('trackBody')),[_c('i',{staticClass:"material-icons"},[_vm._v("person")]),_vm._v(" Go to Athlete profile")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card blue-grey darken-1"},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Congratulations!")]),_vm._v(" "),_c('p',[_vm._v("Well done "+_vm._s(_vm.name)+"! You have completed all your sessions for this week. It is time to come back home...")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('a',{staticClass:"waves-effect waves-light",on:{"click":function($event){return _vm.gotoNext()}}},[_vm._v("Jump into the next week of training\n            ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionRemaining_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12944980_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionRemaining_vue__ = __webpack_require__(496);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionRemaining_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12944980_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionRemaining_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card blue-grey darken-1"},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Opens of the week")]),_vm._v(" "),_c('p',[_vm._v("Hey "+_vm._s(_vm.name)+"! Remind that you still have "+_vm._s(_vm.count)+" "+_vm._s(_vm._f("pluralize")('session',_vm.count))+"  to complete this week.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{attrs:{"to":{name:'Sessions'}}},[_c('i',{staticClass:"material-icons"},[_vm._v("fitness_center")]),_vm._v(" Go to workout\n        ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card pink darken-3"},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Init with your 1RM")]),_vm._v(" "),_c('p',[_vm._v("\n          Incredible "+_vm._s(_vm.name)+", I am sure you know your 1RM back squat, deadlift, press or\n          bench.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{attrs:{"to":{name:'InitRecords'}}},[_c('i',{staticClass:"material-icons"},[_vm._v("flag")]),_vm._v(" Go to Perf. recording\n        ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TargetsRemind_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4e0684_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetsRemind_vue__ = __webpack_require__(499);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TargetsRemind_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4e0684_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetsRemind_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card pink darken-3"},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("See the next level")]),_vm._v(" "),_c('p',[_vm._v("Keep it up, "+_vm._s(_vm.name)+"! Do you know how closed you are from the next level")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{attrs:{"to":{name:'Records', params:{tab: 'perf'}}}},[_c('span',{on:{"click":function($event){return _vm.call('targets')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("flag")]),_vm._v(" Go to Targets")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-board"},[(_vm.isInit())?_c('InitRecordRemind',{attrs:{"name":_vm.name}}):_vm._e(),_vm._v(" "),(_vm.isRecursive(1) && !_vm.isDone('targets'))?_c('TargetsRemind',{attrs:{"name":_vm.name,"callback":_vm.done}}):_vm._e(),_vm._v(" "),(_vm.countRemainingSessions > 0)?_c('SessionRemaining',{attrs:{"name":_vm.name,"count":_vm.countRemainingSessions}}):_vm._e(),_vm._v(" "),(_vm.countRemainingSessions === 0)?_c('SessionCompleted',{attrs:{"name":_vm.name,"user":_vm.user}}):_vm._e(),_vm._v(" "),(_vm.remindTrackBody())?_c('TrackBodyRemind',{attrs:{"name":_vm.name,"callback":_vm.done}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d8703a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(503);
function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d8703a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"validate",attrs:{"id":"email","type":"email"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"email"}},[_vm._v("Email")])]),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"id":"password","type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"password"}},[_vm._v("Password")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s4 offset-s4 "},[_c('router-link',{staticClass:"btn waves-effect waves-light right red accent-2",attrs:{"to":{ name: 'Register' }}},[_vm._v("Register\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col s4"},[_c('button',{staticClass:"btn waves-effect waves-light right",on:{"click":function($event){return _vm.login()}}},[_vm._v("Log in\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"center-align"},[_c('small',[_vm._v(_vm._s(_vm.environment)+" - "+_vm._s(_vm.appVersion)+" "),(_vm.apiPing)?_c('span',{staticClass:"green-text"},[_vm._v("- connected")]):_c('span',{staticClass:"red-text"},[_vm._v("- disconnected")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075fed76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(506);
function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075fed76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"id":"name","type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"name"}},[_vm._v("Name")])]),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",staticClass:"validate",attrs:{"id":"email","type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"email"}},[_vm._v("Email")])])]),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"validate",attrs:{"id":"password","type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("Password")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.activities),function(activity){return _c('div',{key:activity.name,staticClass:"input-field col s6"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trainingPrograms),expression:"trainingPrograms"}],attrs:{"name":"activity","type":"radio","checked":""},domProps:{"value":activity.programs,"checked":_vm._q(_vm.trainingPrograms,activity.programs)},on:{"change":[function($event){_vm.trainingPrograms=activity.programs},function($event){return _vm.changePrograms($event)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(activity.name)+" - "+_vm._s(activity.programs.length)+" days/week")])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.weight),expression:"weight",modifiers:{"number":true}}],staticClass:"validate",attrs:{"id":"weight","type":"number","step":"0.1","min":"0"},domProps:{"value":(_vm.weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.weight=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',[_vm._v("Weight in kg")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s6"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"name":"gender","type":"radio","checked":"","value":"male"},domProps:{"checked":_vm._q(_vm.gender,"male")},on:{"change":function($event){_vm.gender="male"}}}),_vm._v(" "),_c('span',[_vm._v("Male")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"name":"gender","type":"radio","value":"female"},domProps:{"checked":_vm._q(_vm.gender,"female")},on:{"change":function($event){_vm.gender="female"}}}),_vm._v(" "),_c('span',[_vm._v("Female")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn waves-effect waves-light right",attrs:{"name":"action"},on:{"click":function($event){return _vm.register()}}},[_vm._v("Sign Up\n        ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("Select your activity")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("Gender")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Athlete_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf3de34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Athlete_vue__ = __webpack_require__(515);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Athlete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf3de34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Athlete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BodyShape_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35789e54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BodyShape_vue__ = __webpack_require__(510);
function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BodyShape_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35789e54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BodyShape_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s9"},[_c('span',{staticClass:"font-xxlarge"},[_vm._v(_vm._s(_vm._f("NaN")(_vm.bodyFat))+"%")]),_c('small',[_vm._v(" of body fat")])]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('router-link',{attrs:{"to":{ name:'BodyLog' }}},[_c('i',{staticClass:"material-icons medium"},[_vm._v("insert_chart")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.weight),expression:"weight",modifiers:{"number":true,"lazy":true}}],staticClass:"validate",attrs:{"id":"weight","type":"number","step":"0.1","min":"0"},domProps:{"value":(_vm.weight)},on:{"change":function($event){_vm.weight=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong"}},[_vm._v("Weight in kg")])]),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.waist),expression:"waist",modifiers:{"number":true,"lazy":true}}],staticClass:"validate",attrs:{"id":"waist","type":"number","step":"0.1","min":"0"},domProps:{"value":(_vm.waist)},on:{"change":function($event){_vm.waist=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong"}},[_vm._v("Waist in cm")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn waves-effect waves-light right",on:{"click":function($event){return _vm.log()}}},[_vm._v("Log")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Training_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a2be0b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Training_vue__ = __webpack_require__(512);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Training_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a2be0b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Training_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.activities),function(activity){return _c('div',{key:activity.name,staticClass:"input-field col s12"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trainingPrograms),expression:"trainingPrograms"}],attrs:{"name":"activity","type":"radio","checked":""},domProps:{"value":activity.programs,"checked":_vm._q(_vm.trainingPrograms,activity.programs)},on:{"change":[function($event){_vm.trainingPrograms=activity.programs},function($event){return _vm.changePrograms($event)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(activity.name)+" "),_vm._l((activity.programs.length),function(i){return _c('i',{key:i,staticClass:"material-icons tiny blue-text"},[_vm._v("today")])})],2)])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"center"},[_vm._v("Select your activity")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Infos_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4014a886_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Infos_vue__ = __webpack_require__(514);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Infos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4014a886_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Infos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name),expression:"name",modifiers:{"lazy":true}}],attrs:{"id":"name","type":"text"},domProps:{"value":(_vm.name)},on:{"change":function($event){_vm.name=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"name"}},[_vm._v("Name")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"validate",attrs:{"id":"newEmail","type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"newEmail"}},[_vm._v("Change email/login")])]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_c('button',{staticClass:"btn waves-effect waves-light right",on:{"click":function($event){return _vm.changeUsername()}}},[_vm._v("Change\n           ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"validate",attrs:{"id":"password","type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"password"}},[_vm._v("Change password")])]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_c('button',{staticClass:"btn waves-effect waves-light right",on:{"click":function($event){return _vm.changePassword()}}},[_vm._v("Change\n             ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s6"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"name":"gender","type":"radio","checked":"","value":"male"},domProps:{"checked":_vm._q(_vm.gender,"male")},on:{"change":function($event){_vm.gender="male"}}}),_vm._v(" "),_c('span',[_vm._v("Male")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"name":"gender","type":"radio","value":"female"},domProps:{"checked":_vm._q(_vm.gender,"female")},on:{"change":function($event){_vm.gender="female"}}}),_vm._v(" "),_c('span',[_vm._v("Female")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('p',[_c('ul',{ref:"tabs",staticClass:"tabs"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('BodyShape',{staticClass:"col s12",attrs:{"id":"body","user":_vm.user}}),_vm._v(" "),_c('Training',{staticClass:"col s12",attrs:{"id":"training","user":_vm.user}}),_vm._v(" "),_c('Infos',{staticClass:"col s12",attrs:{"id":"info","user":_vm.user}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s5"},[_c('a',{staticClass:"active",attrs:{"href":"#body"}},[_vm._v("Body")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s5"},[_c('a',{attrs:{"href":"#training"}},[_vm._v("Train")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s5"},[_c('a',{attrs:{"href":"#info"}},[_vm._v("Info")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BodyLog_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5295df40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BodyLog_vue__ = __webpack_require__(518);
function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BodyLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5295df40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BodyLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('canvas',{ref:"canvas",staticStyle:{"display":"block","height":"150px","width":"300px"},attrs:{"id":"canvas","width":"100%","height":"100%"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',[_c('router-link',{staticClass:"waves-effect waves-light btn grey left",attrs:{"to":{ name: 'Athlete'}}},[_vm._v("Back\n              "),_c('i',{staticClass:"material-icons right"},[_vm._v("subdirectory_arrow_left")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessions_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e623cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sessions_vue__ = __webpack_require__(524);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e623cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sessions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NextSessionList_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e79c761c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NextSessionList_vue__ = __webpack_require__(521);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NextSessionList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e79c761c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NextSessionList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sortedNextSessions.length > 0)?_c('ul',{staticClass:"collection"},_vm._l((_vm.sortedNextSessions),function(session,index){return _c('li',{key:session.id,staticClass:"collection-item avatar"},[_c('i',{staticClass:"icon-text circle center",class:_vm._f("intensityColor")(session.intensity)},[_vm._v(_vm._s(session.shortCode))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(session.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(session.type)+" "+_vm._s(session.title)+" "),_c('br'),_vm._v(" "),(session.restBefore)?_c('small',[_vm._v("Rest one day before")]):_vm._e()]),_vm._v(" "),(index==0)?_c('router-link',{staticClass:"secondary-content btn-floating pulse",attrs:{"to":{ name: 'Session', params: { session: session, isPastSession: false, user: _vm.user  }}}},[_c('i',{staticClass:"material-icons"},[_vm._v("play_circle_outline")])]):(_vm.isCoach())?_c('router-link',{staticClass:"secondary-content",attrs:{"to":{ name: 'Session', params: { session: session, isPastSession: false, user: _vm.user  }}}},[_c('i',{staticClass:"material-icons"},[_vm._v("pageview")])]):_vm._e()],1)}),0):_c('div',[_c('SessionCompleted',{attrs:{"name":_vm.name,"user":_vm.user,"callback":_vm.callbackSessionListUpdated}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PastSessionList_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7c7462_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PastSessionList_vue__ = __webpack_require__(523);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PastSessionList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7c7462_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PastSessionList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',[_c('tbody',_vm._l((_vm.sortedPastSessions),function(session){return _c('tr',{key:session.id},[_c('td',[_vm._v(_vm._s(_vm._f("toDate")(session.dt)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(session.name))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"secondary-content",class:(session.status == 'Missed') ? 'red-text' : ''},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm._f("statusIconify")(session.status)))])])]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"secondary-content",attrs:{"to":{ name: 'Session', params: { session: session, isPastSession: true, user: _vm.user }}}},[_c('i',{staticClass:"material-icons"},[_vm._v("subdirectory_arrow_right")])])],1)])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('p',[_c('ul',{ref:"tabs",staticClass:"tabs"},[_vm._m(0),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('NextSessionList',{staticClass:"col s12",attrs:{"id":"next","user":_vm.user}}),_vm._v(" "),_c('PastSessionList',{staticClass:"col s12",attrs:{"id":"past","user":_vm.user}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s6"},[_c('a',{staticClass:"active",attrs:{"href":"#next"}},[_vm._v("Next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s6"},[_c('a',{attrs:{"href":"#past"}},[_vm._v("Past")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Session_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf4567b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Session_vue__ = __webpack_require__(534);
function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Session_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf4567b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Session_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.record.unit!=='time')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.lazy.number",value:(_vm.record.value),expression:"record.value",modifiers:{"lazy":true,"number":true}}],staticClass:"validate",attrs:{"id":"record.skill","type":"number","step":"0.25","disabled":_vm.isReadOnly},domProps:{"value":(_vm.record.value)},on:{"change":function($event){_vm.$set(_vm.record, "value", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"record.skill"}},[_vm._v(_vm._s(_vm.record.description))])]):_vm._e(),_vm._v(" "),(_vm.record.unit=='time')?_c('div',[_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy.number",value:(_vm.record.valueMinutes),expression:"record.valueMinutes",modifiers:{"lazy":true,"number":true}}],staticClass:"validate",attrs:{"id":"record.skill + '-Minutes'","type":"number","step":"1","disabled":_vm.isReadOnly},domProps:{"value":(_vm.record.valueMinutes)},on:{"change":function($event){_vm.$set(_vm.record, "valueMinutes", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"record.skill + '-Minutes"}},[_vm._v("Minutes")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy.number",value:(_vm.record.valueSeconds),expression:"record.valueSeconds",modifiers:{"lazy":true,"number":true}}],staticClass:"validate",attrs:{"id":"record.skill + '-Seconds'","type":"number","step":"1","min":"0","max":"60","disabled":_vm.isReadOnly},domProps:{"value":(_vm.record.valueSeconds)},on:{"change":function($event){_vm.$set(_vm.record, "valueSeconds", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"record.skill + '-Seconds'"}},[_vm._v("Seconds")])]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong"}},[_vm._v(_vm._s(_vm.record.description))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[(_vm.session.title)?_c('span',[_vm._v("Session "+_vm._s(_vm.session.title))]):_vm._e()]),_vm._v(" "),_c('ul',{ref:"collapsible",staticClass:"collapsible tasks"},_vm._l((_vm.sortedTasks),function(task,index){return _c('li',{key:index},[_c('div',{staticClass:"collapsible-header"},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm._f("iconifyTask")(task.type)))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.renderTitle(task.title))}}),_vm._v(" "),(task.recordSkill)?_c('i',{staticClass:"material-icons red-text text-accent-2 icon-tiny"},[_vm._v("flag")]):_vm._e(),_vm._v(" "),(task.capTime)?_c('span',{staticClass:"new badge",attrs:{"data-badge-caption":""}},[_vm._v(_vm._s(_vm.getTaskDuration(task))+"'")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('span',[_c('span',{staticClass:"instruction browser-default",domProps:{"innerHTML":_vm._s(_vm.renderInstruction(task.instruction))}}),_vm._v(" "),(task.recordSkill)?_c('InputRecord',{attrs:{"record":task.recordSkill,"isReadOnly":_vm.isPastSession}}):_vm._e()],1)])])])])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s4 left-align"},[(_vm.isPastSession)?_c('router-link',{staticClass:"waves-effect waves-light btn grey left",attrs:{"to":{ name: 'Sessions', query: {tab: 'past'} }}},[_vm._v("Back\n    ")]):_c('router-link',{staticClass:"btn grey ",attrs:{"to":{ name: 'Sessions' }}},[_vm._v("Back\n    ")])],1),_vm._v(" "),(!_vm.isPastSession)?_c('div',{staticClass:"col s4 left-align"},[_c('a',{staticClass:"btn red modal-trigger",attrs:{"href":"#modalDismiss"}},[_vm._v("Missed\n    ")]),_vm._v(" "),_c('div',{ref:"dismissModal",staticClass:"modal",attrs:{"id":"modalDismiss"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"modal-close waves-effect waves-green btn-flat",attrs:{"href":"#!"}},[_vm._v("No")]),_vm._v(" "),_c('a',{staticClass:"modal-close waves-effect waves-green btn-flat",attrs:{"href":"#!"},on:{"click":function($event){return _vm.dismiss()}}},[_vm._v("Yes, Dismiss")])])])]):_vm._e(),_vm._v(" "),(!_vm.isPastSession)?_c('div',{staticClass:"col s4 right-align"},[_c('button',{staticClass:"waves-effect waves-light btn green ",on:{"click":function($event){return _vm.complete()}}},[_vm._v("Done\n    ")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_c('h4',[_vm._v("Dismiss the session")]),_vm._v(" "),_c('p',[_vm._v("Do you confirm you want to DISCARD this session?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Records_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a83c844e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Records_vue__ = __webpack_require__(538);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Records_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a83c844e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Records_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerformanceList_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3830b283_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerformanceList_vue__ = __webpack_require__(537);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerformanceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3830b283_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerformanceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.records.length===0)?_c('InitRecordRemind',{staticClass:"col s12 grey-text lighten-5",attrs:{"name":_vm.name}}):_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v("Skill")]),_vm._v(" "),_c('th',[_vm._v("Current")]),_vm._v(" "),_c('th',[_vm._v("Target")]),_vm._v(" "),_c('th',[_vm._v("Gap%")]),_vm._v(" "),_c('th',[_vm._v("Stats")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.records),function(record){return _c('tr',{key:record.skill},[_c('td',[_vm._v(_vm._s(record.name))]),_vm._v(" "),_c('td',[(record.unit!=='time')?_c('span',[_vm._v(_vm._s(record.value))]):_vm._e(),(record.unit=='time')?_c('span',[_vm._v(_vm._s(record.valueMinutes)+"'"+_vm._s(record.valueSeconds)+"''")]):_vm._e()]),_vm._v(" "),_c('td',[(record.unit!=='time')?_c('span',[_vm._v(_vm._s(record.target))]):_vm._e(),_vm._v(" "),(record.unit=='time')?_c('span',[_vm._v(_vm._s(record.target['minutes'])+"'"+_vm._s(record.target.seconds)+"''")]):_vm._e()]),_vm._v(" "),_c('td',[(record.gap>0)?_c('span',[_vm._v(_vm._s(record.gap)+"%")]):_vm._e(),(record.gap<=0)?_c('i',{staticClass:"material-icons"},[_vm._v("done")]):_vm._e()]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'RecordLog', params: { skill: record.skill }}}},[_c('i',{staticClass:"material-icons"},[_vm._v("insert_chart")])])],1)])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('p',[_c('ul',{ref:"tabs",staticClass:"tabs"},[_vm._m(0)])])]),_vm._v(" "),_c('PerformanceList',{staticClass:"col s12",attrs:{"id":"perf","user":_vm.user}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s6"},[_c('a',{staticClass:"active",attrs:{"href":"#perf"}},[_vm._v("Performances")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecordLog_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357307ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecordLog_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecordLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357307ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecordLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('p',[_c('canvas',{ref:"canvas",staticStyle:{"display":"block","height":"150px","width":"300px"},attrs:{"id":"canvas","width":"100%","height":"70%"}})]),_c('p'),_c('div',{staticClass:"row"},[_c('div',[_c('router-link',{staticClass:"waves-effect waves-light btn grey left",attrs:{"to":{ name: 'Records'}}},[_vm._v("Back\n              "),_c('i',{staticClass:"material-icons right"},[_vm._v("subdirectory_arrow_left")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InitRecords_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76aa88d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InitRecords_vue__ = __webpack_require__(543);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InitRecords_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76aa88d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InitRecords_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.records),function(record){return _c('div',{key:record.skill,staticClass:"row"},[_c('div',{staticClass:"input-field recordInput"},[_c('span',[_vm._v("Your known "+_vm._s(record.name))]),_vm._v(" "),_c('InputRecord',{attrs:{"record":record,"isReadOnly":false}})],1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coach_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9c8f430_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coach_vue__ = __webpack_require__(560);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coach_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9c8f430_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coach_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgramList_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_152b66ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgramList_vue__ = __webpack_require__(553);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgramList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_152b66ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgramList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.programs.length > 0)?_c('ul',{staticClass:"collection"},_vm._l((_vm.programs),function(ref){
var key = ref[0];
var program = ref[1];
return _c('li',{key:key,staticClass:"collection-item avatar"},[_c('i',{staticClass:"icon-text circle center",class:_vm._f("intensityColor")(program.intensity)},[_vm._v(_vm._s(program.code))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(program.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(program.type))]),_vm._v(" "),_c('div',{staticClass:"secondary-content"},[_c('router-link',{attrs:{"to":{ name: 'ProgramEdit', params: { programKey: key, user: _vm.user  }}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.copyProgram(key, program)}}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("content_copy")])]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.deleteProgram(key)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete")])])],1)])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn blue",on:{"click":function($event){return _vm.addProgram()}}},[_vm._v("Add")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillEdit_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dfa59e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillEdit_vue__ = __webpack_require__(557);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dfa59e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 555 */,
/* 556 */,
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('ul',{ref:"collapsible",staticClass:"collapsible tasks"},_vm._l((_vm.sortedSkills),function(ref){
var name = ref[0];
var skill = ref[1];
return _c('li',{key:name},[_c('div',{staticClass:"collapsible-header"},[_vm._v("\n                "+_vm._s(name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s9"},[_c('input',{staticClass:"validate",attrs:{"id":'key-'+name,"type":"text"},domProps:{"value":name},on:{"change":function($event){return _vm.onChangeSkillKey(name, skill,$event)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'key-'+name}},[_vm._v("Key")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skill.init),expression:"skill.init"}],staticClass:"filled-in",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(skill.init)?_vm._i(skill.init,null)>-1:(skill.init)},on:{"change":function($event){var $$a=skill.init,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(skill, "init", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(skill, "init", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(skill, "init", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Init")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skill.name),expression:"skill.name"}],staticClass:"validate",attrs:{"id":'name-'+name,"type":"text"},domProps:{"value":(skill.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(skill, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'name-'+name}},[_vm._v("Name")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s3"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(skill.unit),expression:"skill.unit",modifiers:{"number":true}}],staticClass:"validate",attrs:{"id":'unit-'+name,"type":"text"},domProps:{"value":(skill.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(skill, "unit", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'unit-'+name}},[_vm._v("Unit")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(skill.type),expression:"skill.type"}],staticClass:"browser-default",attrs:{"id":'type-'+name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(skill, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.skillTypes),function(type){return _c('option',{key:type.name,domProps:{"value":type.name}},[_vm._v("\n                      "+_vm._s(type.label)+"\n                    ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skill.targetFormula),expression:"skill.targetFormula"}],staticClass:"validate",attrs:{"id":'targetFormula-'+name,"type":"text"},domProps:{"value":(skill.targetFormula)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(skill, "targetFormula", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'targetFormula-'+name}},[_vm._v("Target Formula")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(skill.description),expression:"skill.description"}],staticClass:"browser-default",attrs:{"id":'description-'+name,"rows":"5"},domProps:{"value":(skill.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(skill, "description", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'description-'+name}},[_vm._v("Description")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s3"}),_vm._v(" "),_c('div',{staticClass:"col s9"},[_c('a',{staticClass:"right",on:{"click":function($event){return _vm.removeSkill(name)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete")])])])])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn blue ",on:{"click":function($event){return _vm.addSkill()}}},[_vm._v("Add\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col s6 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn green ",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityList_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b6e212_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityList_vue__ = __webpack_require__(559);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b6e212_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('ul',{ref:"collapsible",staticClass:"collapsible tasks"},_vm._l((_vm.activities),function(activity,index){return _c('li',{key:activity.name},[_c('div',{staticClass:"collapsible-header"},[_vm._v("\n                "+_vm._s(activity.name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(activity.name),expression:"activity.name",modifiers:{"lazy":true}}],staticClass:"validate",attrs:{"id":'name-'+index,"type":"text"},domProps:{"value":(activity.name)},on:{"change":function($event){return _vm.$set(activity, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'name-'+index}},[_vm._v("Name")])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.programs),function(program){return _c('div',{key:program[0],staticClass:"col s6"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(activity.programs),expression:"activity.programs"}],staticClass:"filled-in",attrs:{"id":program[0]+'-'+index,"type":"checkbox"},domProps:{"value":program[0],"checked":Array.isArray(activity.programs)?_vm._i(activity.programs,program[0])>-1:(activity.programs)},on:{"change":function($event){var $$a=activity.programs,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=program[0],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(activity, "programs", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(activity, "programs", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(activity, "programs", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(program[1].name))])])])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s3"}),_vm._v(" "),_c('div',{staticClass:"col s9"},[_c('a',{staticClass:"right",on:{"click":function($event){return _vm.remove(index)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete")])])])])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn blue ",on:{"click":function($event){return _vm.add()}}},[_vm._v("Add\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col s6 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn green ",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('p',[_c('ul',{ref:"tabs",staticClass:"tabs"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('ActivityList',{staticClass:"col s12",attrs:{"id":"activities","user":_vm.user}}),_vm._v(" "),_c('ProgramList',{staticClass:"col s12",attrs:{"id":"programs","user":_vm.user}}),_vm._v(" "),_c('SkillList',{staticClass:"col s12",attrs:{"id":"skills","user":_vm.user}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s4"},[_c('a',{attrs:{"href":"#activities"}},[_vm._v("Activities")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s4"},[_c('a',{attrs:{"href":"#programs"}},[_vm._v("Programs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s4"},[_c('a',{attrs:{"href":"#skills"}},[_vm._v("Skills")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgramEdit_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56731b1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgramEdit_vue__ = __webpack_require__(567);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgramEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56731b1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgramEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = arrayRemove;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrayMoveUp;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayMoveDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

function arrayRemove(arr, i) {
  if (delete arr[i]) {
    return arr.filter(function (x) {
      return typeof x !== 'undefined';
    });
  } else {
    throw new Error('Out of bound index');
  }
}

function arrayMoveUp(arr, i) {
  var c = arr[i];
  if (i > 0) {
    arr[i] = arr[i - 1];
    arr[i - 1] = c;
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr);
}

function arrayMoveDown(arr, i) {
  var c = arr[i];
  if (i < arr.length - 1) {
    arr[i] = arr[i + 1];
    arr[i + 1] = c;
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr);
}

/***/ }),
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col s12"},[_c('p',[_c('ul',{ref:"tabs",staticClass:"tabs"},[_vm._m(0),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"program"}},[_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.program.name),expression:"program.name"}],staticClass:"validate",attrs:{"id":"program-key","type":"text"},domProps:{"value":(_vm.program.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.program, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"program-key"}},[_vm._v("Key")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.program.description.code),expression:"program.description.code"}],staticClass:"validate",attrs:{"id":"program-code","type":"text"},domProps:{"value":(_vm.program.description.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.program.description, "code", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"program-code"}},[_vm._v("Code")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.program.description.name),expression:"program.description.name"}],staticClass:"validate",attrs:{"id":"program-name","type":"text"},domProps:{"value":(_vm.program.description.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.program.description, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"program-name"}},[_vm._v("Name")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.program.description.type),expression:"program.description.type"}],staticClass:"validate",attrs:{"id":"program-type","type":"text"},domProps:{"value":(_vm.program.description.type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.program.description, "type", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"program-type"}},[_vm._v("Type")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.program.description.intensity),expression:"program.description.intensity"}],staticClass:"browser-default",attrs:{"id":"program-intensity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.program.description, "intensity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.intensities),function(intensity){return _c('option',{key:intensity,domProps:{"value":intensity}},[_vm._v("\n            "+_vm._s(intensity)+"\n          ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"sessions"}},[_c('ul',{ref:"collapsible",staticClass:"collapsible tasks"},_vm._l((_vm.sortedSessions),function(ref){
var name = ref[0];
var session = ref[1];
return _c('li',{key:name},[_c('div',{staticClass:"collapsible-header"},[_vm._v("\n                "+_vm._s(name)+" - "+_vm._s(session.title)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{staticClass:"validate",attrs:{"id":'key-'+name,"type":"text"},domProps:{"value":name},on:{"change":function($event){return _vm.onChangeSessionKey(name, session,$event)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'key-'+name}},[_vm._v("Sequence")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(session.title),expression:"session.title"}],staticClass:"validate",attrs:{"id":'title-'+name,"type":"text"},domProps:{"value":(session.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(session, "title", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'title-'+name}},[_vm._v("Session title")])])]),_vm._v(" "),_c('ul',{staticClass:"collection"},_vm._l((session.tasks),function(task,index){return _c('li',{key:index,staticClass:"collection-item"},[(task)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s3"},[_c('b',[_vm._v("Task #"+_vm._s(index))])]),_vm._v(" "),_c('div',{staticClass:"col s9"},[_c('a',{on:{"click":function($event){return _vm.insertTask(session, task)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v("\n                           \n                            "),_c('a',{on:{"click":function($event){return _vm.moveTaskUp(session, task)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_upward")])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.moveTaskDown(session, task)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_downward")])]),_vm._v("\n                             \n                            "),_c('a',{staticClass:"right",on:{"click":function($event){return _vm.removeTask(session, task)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.title),expression:"task.title"}],staticClass:"validate",attrs:{"id":'title-'+name+'-'+index,"type":"text"},domProps:{"value":(task.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(task, "title", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'title-'+name+'-'+index}},[_vm._v("Title")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(task.capTime),expression:"task.capTime",modifiers:{"number":true}}],staticClass:"validate",attrs:{"id":'capTime-'+name+'-'+index,"type":"text"},domProps:{"value":(task.capTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(task, "capTime", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'capTime-'+name+'-'+index}},[_vm._v("Cap")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(task.type),expression:"task.type"}],staticClass:"browser-default",attrs:{"id":'type-'+name+'-'+index},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(task, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.taskTypes),function(type){return _c('option',{key:type.name,domProps:{"value":type.name}},[_vm._v("\n                              "+_vm._s(type.label)+"\n                            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(task.withRecord),expression:"task.withRecord"}],staticClass:"browser-default",attrs:{"id":'withRecord-'+name+'-'+index},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(task, "withRecord", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("No record")]),_vm._v(" "),_vm._l((_vm.skills),function(ref){
var code = ref[0];
var skill = ref[1];
return _c('option',{key:code,domProps:{"value":code}},[_vm._v("\n                              "+_vm._s(skill.name)+"\n                            ")])})],2),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'withRecord-'+name+'-'+index}},[_vm._v("Record skill")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(task.instruction),expression:"task.instruction"}],staticClass:"browser-default",attrs:{"id":'instruction-'+name+'-'+index,"rows":"5"},domProps:{"value":(task.instruction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(task, "instruction", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":'instruction-'+name+'-'+index}},[_vm._v("Instruction")])])])]):_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s3"},[_c('b',[_vm._v("Task #"+_vm._s(index))])]),_vm._v(" "),_c('div',{staticClass:"col s9"},[_c('a',{staticClass:"right",on:{"click":function($event){return _vm.removeTask(session, task)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])])])])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('a',{staticClass:"btn left red",on:{"click":function($event){return _vm.removeSession(name)}}},[_vm._v("REMOVE SESSION")])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('a',{staticClass:"btn right blue",on:{"click":function($event){return _vm.copySession(name)}}},[_vm._v("COPY SESSION")])])])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s4 left-align"},[_c('router-link',{staticClass:"waves-effect waves-light btn grey ",attrs:{"to":{ name: 'Coach', params:{tab:'programs'}}}},[_vm._v("Back\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"col s4 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn blue ",on:{"click":function($event){return _vm.addSession()}}},[_vm._v("Add\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col s4 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn green ",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s6"},[_c('a',{staticClass:"active",attrs:{"href":"#program"}},[_vm._v("Description")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab s6"},[_c('a',{attrs:{"href":"#sessions"}},[_vm._v("Sessions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Credits_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca93590_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Credits_vue__ = __webpack_require__(569);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Credits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca93590_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Credits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('p',[_vm._v("\n           Credits : ©Julien Cabot - 2019-2020\n       ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n         Version : "+_vm._s(_vm.appVersion)+" "),_c('br'),_vm._v("\n         Environment : "+_vm._s(_vm.environment)+" "),_c('br'),_vm._v("\n         PSN : "+_vm._s(this.user.athlete.progSeqNum)+"\n       ")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.isDevMode())?_c('div',{staticClass:"row"},[_vm._v("\n         ADVANCED MODE "),_c('br'),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.progSeqNum),expression:"progSeqNum",modifiers:{"number":true,"lazy":true}}],staticClass:"validate",attrs:{"type":"number","step":"1","min":"0"},domProps:{"value":(_vm.progSeqNum)},on:{"change":function($event){_vm.progSeqNum=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"helper-text"},[_vm._v("Prog Sequence Number")])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.forceSessionUpdate()}}},[_vm._v("CHANGE")])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Device_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6502d770_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Device_vue__ = __webpack_require__(571);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Device_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6502d770_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Device_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('a',{staticClass:"waves-effect waves-light btn blue col s3 ",on:{"click":function($event){return _vm.displayDeviceInfo()}}},[_vm._v("Start")]),_vm._v(" "),_c('span',{staticClass:"col s6"},[_vm._v(_vm._s(_vm.deviceName))]),_vm._v(" "),(_vm.deviceIsConnected)?_c('a',{staticClass:"waves-effect waves-light btn blue col s3 ",on:{"click":function($event){return _vm.reset()}}},[_vm._v("Reset")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s4"},[_vm._v("X="+_vm._s(_vm.accelero_x))]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_vm._v("Y="+_vm._s(_vm.accelero_y))]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_vm._v("Z="+_vm._s(_vm.accelero_z))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s4"},[_vm._v("Acc="+_vm._s(_vm.accelero_distance))]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_vm._v("Max="+_vm._s(_vm.accelero_distance_max))]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_vm._v("Total="+_vm._s(_vm.accelero_distance_sum))])]),_vm._v(" "),_c('i',{staticClass:"material-icons",style:({fontSize:_vm.accelero_distance*20+'px'})},[_vm._v("fitness_center")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
/* harmony export (immutable) */ __webpack_exports__["c"] = intensityColor;
/* harmony export (immutable) */ __webpack_exports__["b"] = iconifyTask;
function pluralize(word, amount) {
  return amount > 1 || amount === 0 ? word + 's' : word;
}

function capitalize(word) {
  return word.toUpperCase();
}

function intensityColor(val) {
  switch (val) {
    case 'High':
      return 'red';
    case 'Medium':
      return 'blue';
    case 'Low':
      return 'green';
  }
}

function iconifyTask(val) {
  switch (val) {
    case 'mobility':
      return 'filter_drama';
    case 'warmup':
      return 'whatshot';
    case 'oly':
      return 'fitness_center';
    case 'weight':
      return 'fitness_center';
    case 'gym':
      return 'accessibility';
    case 'cardio':
      return 'directions_run';
    default:
      return 'fitness_center';
  }
}

/***/ })
],[320]);


// WEBPACK FOOTER //
// static/js/app.93bb77f2e4419ef473db.js